export const getCalloutExtensionStyles = () => ({
  calloutExtensionContainer: {
    color: '#767676',
    fontFamily: 'Roboto',
    lineHeight: '22px',
  },
});

export const getPriceExtensionStyles = () => ({
  priceExtensionContainer: {
    color: '#4007A2',
    fontFamily: 'Roboto',
    lineHeight: '22px',
    '& a': {
      color: '#4007A2',
    },
    '& div': {
      display: 'inline-block',
    },
  },
});

export const getPromotionExtensionStyles = () => ({
  promotionExtensionContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& .promotion-info': {
      '& span': {
        color: '#767676',
        fontFamily: 'Roboto',
        lineHeight: '22px',
      },
      '& .discount': {
        color: '#1A0DAB',
      },
    },
    '& .promotion-rate': {
      display: 'flex',
      alignItems: 'center',
      gap: '3px',
      '& span': {
        color: '#767676',
        fontFamily: 'Roboto',
        fontWeight: '700',
        lineHeight: '22px',
      },
      '& .rating-icons': {
        marginTop: '-2px',
        display: 'flex',
      },
      '& .reviews': {
        color: '#767676',
        fontWeight: '400',
      },
    },
  },
});

export const getSitelinkExtensionStyles = () => ({
  sitelinkExtensionContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& .sitelink-row': {
      display: 'flex',
      gap: '48px',
      marginTop: '12px',
      '& .sitelink-tile': {
        width: '270px',
        display: 'flex',
        flexDirection: 'column',
        gap: '3px',
        '& .title': {
          color: '#4007A2',
          fontFamily: 'Roboto',
          fontSize: '20px',
          lineHeight: '24px',
        },
        '& .text': {
          color: '#666',
          fontFamily: 'Roboto',
          lineHeight: '22px',
        },
      },
    },
  },
});

export const getStructuredSnippetExtensionStyles = () => ({
  structuredSnippetExtensionContainer: {
    '& .category': {
      color: '#767676',
      fontFamily: 'Roboto',
      fontWeight: '700',
      lineHeight: '22px',
    },
    '& .texts': {
      color: '#767676',
      fontFamily: 'Roboto',
      lineHeight: '22px',
    },
  },
});
